import React, { useEffect, useState } from "react";
import { Box, Chip, CircularProgress, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import PersonIcon from "@mui/icons-material/Person";
import PersonAvatar from "../../../PersonAvatar";

// "Kto idzie?": you are always in, accepted friends are toggled on as chips.
// Who pays for which seat is shown below the payment choice (GroupSummary).
const FriendSelector = ({ user, maxFriends, selected, onChange, isDuo }) => {
  const [friends, setFriends] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const idToken = await user.getIdToken();
        const resp = await fetch(`${process.env.REACT_APP_BACKEND_ADDRESS}/friends/`, {
          headers: { Authorization: `Bearer ${idToken}` },
        });
        const data = resp.ok ? await resp.json() : { friends: [] };
        if (!cancelled) setFriends((data.friends || []).map((f) => f.friend));
      } catch {
        if (!cancelled) setFriends([]);
      }
    };
    if (user) load();
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (friends === null) {
    return <CircularProgress size={20} />;
  }

  if (friends.length === 0) {
    return null;
  }

  const toggle = (id) => {
    if (selected.includes(id)) {
      onChange(selected.filter((x) => x !== id));
    } else if (selected.length < maxFriends) {
      onChange([...selected, id]);
    }
  };

  return (
    <Box data-testid="friend-selector">
      <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="subtitle2" fontWeight={600}>
          Kto idzie?
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {isDuo ? `maks. ${maxFriends + 1} os.` : `wolne miejsca: ${maxFriends + 1}`}
        </Typography>
      </Box>
      <Stack direction="row" useFlexGap flexWrap="wrap" gap={1}>
        <Chip
          icon={<PersonIcon />}
          label="Ty"
          color="primary"
          data-testid="me-chip"
        />
        {friends.map((friend) => {
          const checked = selected.includes(friend.id);
          const full = !checked && selected.length >= maxFriends;
          return (
            <Chip
              key={friend.id}
              data-testid="friend-chip"
              aria-pressed={checked}
              icon={checked ? <CheckIcon /> : undefined}
              avatar={checked ? undefined : <PersonAvatar name={friend.full_name} size={24} />}
              label={friend.full_name}
              color={checked ? "primary" : "default"}
              variant={checked ? "filled" : "outlined"}
              disabled={full}
              onClick={() => toggle(friend.id)}
            />
          );
        })}
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
        {isDuo
          ? "Rezerwujesz całe zajęcia i płacisz za całą rezerwację."
          : "Za znajomych płacisz Ty, chyba że pokryje to ich własny karnet."}
      </Typography>
    </Box>
  );
};

export default FriendSelector;
